import { Map, Truck, Receipt, Workflow, BarChart3, Users } from 'lucide-react'

const FEATURES = [
  { icon: Map, title: 'Ugurlar we aralyklar' },
  { icon: Truck, title: 'Ulaglar we daşaýjylar' },
  { icon: Workflow, title: 'Baha → Sargyt → Hasap' },
  { icon: Receipt, title: 'Hasaplar we tölegler' },
  { icon: BarChart3, title: 'Marja we hasabat' },
  { icon: Users, title: 'Topar iş giňişligi' },
]

export function Features() {
  return (
    <section id="features" className="border-b border-border bg-muted/30">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 py-16 lg:py-24">
        <div className="max-w-2xl mb-10">
          <p className="eyebrow text-primary mb-3">Mümkinçilikler</p>
          <h2 className="text-[28px] sm:text-[36px] leading-tight font-semibold tracking-tight">
            Bütin akymy üçin ýeke-täk iş giňişligi.
          </h2>
        </div>

        <ul
          className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-px bg-border rounded-2xl overflow-hidden border border-border"
          role="list"
        >
          {FEATURES.map(({ icon: Icon, title }) => (
            <li key={title} className="bg-background p-5 flex flex-col items-start gap-3">
              <div className="w-8 h-8 rounded-lg bg-primary/10 text-primary flex items-center justify-center">
                <Icon className="w-4 h-4" />
              </div>
              <p className="text-[14.5px] font-semibold tracking-tight leading-snug">{title}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
